import React, { useState } from 'react';
import MainDisplay from './components/MainDisplay';
import ForecastCards from './components/layout/ForecastCards';
import VibesPlayer from './components/layout/VibesPlayer';
import { fetchWeather } from './services/WeatherService';
import { getVibeForCondition } from './services/VibeService';
import { WeatherData, ForecastDay, WeatherLocation } from './types/WeatherData';

const App: React.FC = () => {
  const [weatherData, setWeatherData] = useState<WeatherData | null>(null);
  const [forecastData, setForecastData] = useState<ForecastDay[]>([]);
  const [vibeData, setVibeData] = useState<any>(null);
  const [location, setLocation] = useState<WeatherLocation | null>(null);

  const handleLocationSubmit = async (loc: string) => {
    try {
      const response = await fetchWeather(loc);
      if (response) {
        const { weather } = response;
        setLocation(weather.location);
        setWeatherData(weather.current);
        setForecastData(weather.forecast.forecastday);
        setVibeData(getVibeForCondition(weather.current.condition.text));
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="main-container">
      <MainDisplay
        weatherData={weatherData}
        cityName={location?.name ?? ''}
        onLocationSubmit={handleLocationSubmit}
        vibeData={vibeData}
      />
      <ForecastCards forecastData={forecastData} />
      <VibesPlayer title={vibeData?.title} url={vibeData?.url} />
    </div>
  );
};

export default App;
